import { render, staticRenderFns } from "./copyrightWorksDisplay.vue?vue&type=template&id=7fe699de&scoped=true&"
import script from "./copyrightWorksDisplay.vue?vue&type=script&lang=js&"
export * from "./copyrightWorksDisplay.vue?vue&type=script&lang=js&"
import style0 from "./copyrightWorksDisplay.vue?vue&type=style&index=0&id=7fe699de&prod&lang=less&scoped=true&"
import style1 from "./copyrightWorksDisplay.vue?vue&type=style&index=1&id=7fe699de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe699de",
  null
  
)

export default component.exports